import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericIdbaService } from '../generic-idba-service.service';
import { Job } from '../../models/bas/job';
import { GenericIdbaRequestModel } from '../../models/generic-idba-request-model';


@Injectable({
  providedIn: 'root'
})
export class JobService extends GenericIdbaService {

  declare model: Job;

  constructor(http: HttpClient) {
    super(http, new Job());
    this.programName = "bas/job/job.p";
  }

  pesquisarLogs(params) {
    var request: GenericIdbaRequestModel = new GenericIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-job-logs';
    request.parameters = params;
    return this.httpClient.post<any>(this.configService.getApiUrl('integrateUrl'), request, {
      observe: 'response',
    });
  }

  pesquisarLogsTabela(tabela: string, idTabela: number) {
    var request: GenericIdbaRequestModel = new GenericIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-job-logs-tabela';
    request.parameters = { tabela, idTabela };
    return this.httpClient.post<any>(this.configService.getApiUrl('integrateUrl'), request, {
      observe: 'response',
    });
  }

  buscaInformacoesJob(nomeTabela: string, idTabela: number) {
    var request: GenericIdbaRequestModel = new GenericIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-job-logs-por-registro';
    request.parameters = { nomeTabela, idTabela };
    return this.httpClient.post<any>(this.configService.getApiUrl('integrateUrl'), request, {
      observe: 'response',
    });
  }

}
